import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';
import * as wbsActions from '../../../../store/actions/wbs';
import WbsDataContainer from './WbsDataContainer';
import SubmitPanelContainer from './SubmitPanelContainer';
const styles = {
    container: {
        paddingTop: '20px',
        maxWidth: 928,
        margin: '0 auto',
        paddingRight: '48px',
        display: 'flex',
        position: 'relative'
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.wbsForm.loading || state.wbsForm.submitting
    }
}

  const mapDispatchToProps = (dispatch) => ({
      loadView: () => {
        dispatch(wbsActions.wbsFormInitializeStarted());
      },
      loadEditForm: (payload) =>
        dispatch(wbsActions.wbsEditFormInitializeStarted(payload)),
      resetForm: () => {
        dispatch(wbsActions.resetWbsForm());
      }
  });
class DeliveryConfirmationApproverForm extends Component {
    componentDidMount() {
        if (this.props.location.pathname.indexOf('/masterdata/viewallwbses') === -1) {
            this.props.loadView();
        } else {
            this.props.loadEditForm(this.props.location.pathname.split('/')[3]);
        }
    }
    componentWillUnmount() {
        this.props.resetForm();
    }
    render () {
        return (
            <div className={this.props.classes.container}>
                <LoadingSpinner loading={this.props.loading} spinnerCentered={true}></LoadingSpinner>
                <Grid container className="form-grid" spacing={2}>
                    <Grid item xs={12}>
                        <WbsDataContainer />
                    </Grid>                    
                    <Grid item xs={12}>
                        <SubmitPanelContainer />
                    </Grid>
                </Grid>
            </div>
        )
    }
}


  export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(DeliveryConfirmationApproverForm);